import React, { createContext, useState, useContext } from 'react'

const MonitoringAndEvaluationContext = createContext()

export const MonitoringAndEvaluationProvider = (props) => {
  const [monitoringAndEvaluationForm, setMonitoringAndEvaluationForm] =
    useState({})

  return (
    <MonitoringAndEvaluationContext.Provider
      value={{
        monitoringAndEvaluationForm,
        setMonitoringAndEvaluationForm,
      }}
    >
      {props.children}
    </MonitoringAndEvaluationContext.Provider>
  )
}

export const useFormMonitoringAndEvaluation = () => {
  const context = useContext(MonitoringAndEvaluationContext)
  if (context === undefined) {
    throw new Error(
      'useFormMonitoringAndEvaluation can only be used inside FormProvider',
    )
  }
  return context
}
